import React from 'react';
import NoResult from './questionChartsNoResult';
import { BarChart } from '@citrus/chart';
import { ZeroState } from '@citrus/zero-state';
import {
  Table,
  Tbody,
  Td,
  Tr,
  Th,
  Thead,
} from '@citrus/data-table';


const ConstantSumChart = ({responses, number, responseCount, isSummary}) => {
  if(responses === null || responses.length === 0 || typeof(responses) !== typeof([])) {
    return (<NoResult number={number}/>);
  }
  const stats = [];
  const categories = [];
  responses.sort((a, b) => Number(b.sum) - Number(a.sum));
  responses.forEach((response, index) => {
    var average = Math.round(((response.sum / responseCount) + Number.EPSILON) * 100) / 100;
    var series = [];
    for(let i=0; i < index; i++){
      series.push(0)
    }
    series.push(average);
    stats.push({name: response.text, series: series});
    categories.push(response.text);
  });

 
  return (
    <React.Fragment>
      <BarChart
      config={{
        plotOptions: {
            series: {
                stacking: 'normal',
                showInLegend: false
            }
        },
      }}
      data={stats}
      xAxis={{ categories: categories }}    
      automationId={"question-" + number + "-constantsum-chart"}
      />

      {!isSummary && <Table.Core
        automationId={"question-" + number + "-constantsum-graph"}
        itemCount={responseCount}
        onChangePage={() => {}}
        page={1}
        pageSize={Number.MAX_SAFE_INTEGER}
        css={"div > div > div > span { display: none }"}
        renderZeroState={() => <ZeroState type="insufficientdata" />}>
          <Thead>
            <Th column="Item">Item</Th>
            <Th column="Total">Total</Th>
            <Th column="Min">Min</Th>
            <Th column="Max">Max</Th>
            <Th column="Mean">Mean</Th>
            <Th column="Responses">Responses</Th>
          </Thead>
          <Tbody>
            {responses.map((response) => (
              <Tr key={response.value}>
                <Td>{response.text}</Td>
                <Td>{response.sum}</Td>
                <Td>{Math.min(...response.constantSumValues)}</Td>
                <Td>{Math.max(...response.constantSumValues)}</Td>
                <Td>{Math.round(((response.sum / responseCount) + Number.EPSILON) * 100) / 100}</Td>
                <Td>{responseCount}</Td>
              </Tr>))
            }
          </Tbody>
      </Table.Core>}
    </React.Fragment>
  );
}

export default ConstantSumChart;